<script>
	export let center = false;
	export let gray = false;
	export let paddingtop = 0;
	export let paddingbottom = 0;
</script>

<section
	class="UISection"
	class:_center={center}
	class:_gray={gray}
	style={`padding-top:${paddingtop};padding-bottom:${paddingbottom};`}
>
	<div class="UISection-box"><slot /></div>
</section>

<style global>
	.UISection {
		padding-left: 1em;
		padding-right: 1em;
	}
	.UISection._center {
		text-align: center;
	}
	:global(.pc) .UISection {
		padding-left: 2em;
		padding-right: 2em;
	}
	.UISection-box {
		margin: 0 auto;
		max-width: 1140px;
	}
	.UISection._gray {
		background-color: #eee;
	}
</style>
